import { Theme, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import { T } from 'react-polyglot-hooks';

const useStyles = makeStyles((theme :Theme) => ({
  root: {
    padding: theme.spacing(4)
  }
}));

const Footer = (props :{ className?:string }) => {
  const { className, ...rest } = props;

  const classes = useStyles();

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Typography variant="body1">
        &copy;{' '}WCV. 2021
      </Typography>
      <Typography variant="caption">
      </Typography>
    </div>
  );
};

export default Footer;
